import React, { createContext, useState, useContext } from 'react';

// Create a Context for authentication
const AuthContext = createContext();

// Custom hook to use authentication context
export const useAuth = () => {
  return useContext(AuthContext);
};

// AuthProvider to wrap the application and provide authentication state
export const AuthProvider = ({ children }) => {
  const isauth = !localStorage.getItem('authToken');
  const [isAuthenticated, setIsAuthenticated] = useState(!isauth);
  const login = () => {
    setIsAuthenticated(true);
  };

  const logout = () => {
    setIsAuthenticated(false);
  };

  return <AuthContext.Provider value={{ isAuthenticated, login, logout }}>{children}</AuthContext.Provider>;
};
